export default {"src":"/_next/static/media/heart.b31338c5.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};